<template>
  <div>
  </div>
</template>

<script>
export default {
  name: "index",
  mounted() {
    window.open("http://mylan.lantogis.com/")
    this.$router.back()
  },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Container/index.vue